import {
    District,
    Entity,
    Municipality,
    Neighbourhood,
    Province,
    Region,
} from '../locations/index.js';

const MapboxMaxZoom = 24;

const MaxZoomLevels = {
    [ Region ]: 6,
    [ Province ]: 9.5,
    [ Municipality ]: 13,
    [ District ]: 13,
    [ Neighbourhood ]: 14,
    [ Entity ]: 13,
};

export default MaxZoomLevels;

export {
    MapboxMaxZoom,
};
